import { createSlice, createSelector } from "@reduxjs/toolkit";
import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap, map, catchError } from "rxjs/operators";
const SPORT_FEATURE_KEY = "sport";
const initialSportState = {
  entities: [],
  loaded: false,
  error: null,
  selectedAlias: null
};
const sportSlice = createSlice({
  name: SPORT_FEATURE_KEY,
  initialState: initialSportState,
  reducers: {
    getSportStart: (state, action) => {
      state.loaded = false;
    },
    getSportSuccess: (state, action) => {
      state.loaded = true;
      state.entities = action.payload;
    },
    getSportFailure: (state, action) => {
      state.error = action.payload;
    }
  }
});
const sportReducer = sportSlice.reducer;
const {
  getSportStart,
  getSportSuccess,
  getSportFailure
} = sportSlice.actions;
const getSportState = (rootState) => rootState[SPORT_FEATURE_KEY];
const popular = [2, 5, 7, 10, 3, 1, 4];
const popularSports = popular;
const selectSportEntities = createSelector(
  getSportState,
  (s) => s.entities
);
const selectSportEntitiesPopular = createSelector(getSportState, (s) => s.entities.filter((sport) => popular.includes(Number(sport.id))));
const selectSportEntitiesNotPopular = createSelector(
  getSportState,
  (s) => s.entities.filter((sport) => !popular.includes(Number(sport.id)))
);
const selectActiveAlias = createSelector(
  getSportState,
  (s) => s.selectedAlias
);
const selectSportByAlias = createSelector(
  getSportState,
  (state, alias) => alias,
  (s, a) => s.entities.find((sport) => sport.alias === a)
);
const selectStoreSportById = createSelector(
  getSportState,
  (state, id) => id,
  (s, id) => s.entities.find((sport) => Number(sport.id) === Number(id))
);
const selectActiveSport = createSelector(getSportState, (s) => s.entities.map((entity) => entity.id));
const selectSportEntitiesIds = createSelector(getSportState, (s) => s.entities.map((entity) => entity.id));
const selectSportLoaded = createSelector(getSportState, (s) => s.loaded);
const selectSportError = createSelector(getSportState, (s) => s.error);
const fetchSport = (countryCode, period = 0) => ({
  type: getSportStart.type
});
const fetchSportEpic = (action$, state$, { Api }) => action$.pipe(
  ofType(getSportStart.type),
  switchMap(() => Api.sport.getSportLine(null, "sports").pipe(
    map((sportList) => getSportSuccess(sportList)),
    catchError((err) => of(getSportFailure(err)))
  ))
);
export {
  SPORT_FEATURE_KEY,
  fetchSport,
  fetchSportEpic,
  getSportFailure,
  getSportStart,
  getSportState,
  getSportSuccess,
  initialSportState,
  popularSports,
  selectActiveAlias,
  selectActiveSport,
  selectSportByAlias,
  selectSportEntities,
  selectSportEntitiesIds,
  selectSportEntitiesNotPopular,
  selectSportEntitiesPopular,
  selectSportError,
  selectSportLoaded,
  selectStoreSportById,
  sportReducer,
  sportSlice
};
